define([
	'internal_util/Logger',
	'internal_util/Util',
	'model/Error',
	'model/ErrorType',
	'state/UIState',
	'service/UIStateManager',
	'service/EventListenerRegistry',
	'view/SplashScreenView',
	'view/ErrorView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/InitializationState_strings'
], function (
	Logger,
	Util,
	Error,
	ErrorType,
	UIState,
	UIStateManager,
	EventListenerRegistry,
	SplashScreenView,
	ErrorView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * InitializationState class
	 */
	function InitializationState(uiStateManager) {
		var _uiStateManager,
			_splashScreenView = new SplashScreenView(),
			_controlBarView = new ControlBarView('skIdS_control-bar-initialization');

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

//		_controlBarView.addButton(CommonStrings.abort, function () {
//			_uiStateManager.abort();
//		});

		UIState.call(this, 'initialization');


		// private methods

		function setStatusText(text, doneCallback) {
			_splashScreenView.setStatusText(text);

			Util.callCallbacks(doneCallback);
		}

		function errorOccurred(error, doneCallback) {
			if (error.type() === ErrorType.NON_RECOVERABLE) {
				_uiStateManager.change('error', error);
			}

			Util.callCallbacks(doneCallback);
		}


		// public methods

		this.title = function () {
			return null;
		};
		
		this.poweredByImage = function () {
			return null;
		};

		this.content = function () {
			return _splashScreenView;
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback) {
			_splashScreenView.enableAnimation();

			EventListenerRegistry.addOneTimeListener('WEBFONTS_LOADING_STARTED', function (data, doneCallback) {
				setStatusText(Strings.webfonts_loading, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('IMAGES_LOADING_STARTED', function (data, doneCallback) {
				setStatusText(Strings.images_loading, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('GET_ATTRIBUTE_DEFINITIONS_STARTED', function (data, doneCallback) {
				setStatusText(Strings.get_attribute_definitions, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_STARTED', function (data, doneCallback) {
				setStatusText(Strings.openecard_supported_cards_prototols, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('GET_OPTIONS_STARTED', function (data, doneCallback) {
				setStatusText(Strings.get_options, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('EID_CLIENT_DETECTION_STARTED', function (data, doneCallback) {
				setStatusText(Strings.eid_client_detection, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('GET_CLOUD_IDENTITY_OPTIONS_STARTED', function (data, doneCallback) {
				setStatusText(Strings.get_cloud_identity_options, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('GET_CLOUD_IDENTITY_STARTED', function (data, doneCallback) {
				setStatusText(Strings.get_cloud_identity, doneCallback);
			});


			EventListenerRegistry.addOneTimeListener('WEBFONTS_LOADING_SUCCEEDED', function (data, doneCallback) {
				setStatusText(Strings.webfonts_loading + Strings.done, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('IMAGES_LOADING_SUCCEEDED', function (data, doneCallback) {
				setStatusText(Strings.images_loading + Strings.done, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('GET_ATTRIBUTE_DEFINITIONS_SUCCEEDED', function (data, doneCallback) {
				setStatusText(Strings.get_attribute_definitions + Strings.done, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_SUCCEEDED', function (data, doneCallback) {
				setStatusText(Strings.openecard_supported_cards_prototols + Strings.done, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('GET_OPTIONS_SUCCEEDED', function (data, doneCallback) {
				setStatusText(Strings.get_options + Strings.done, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', function (data, doneCallback) {
				setStatusText(Strings.eid_client_detection + Strings.done, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('GET_CLOUD_IDENTITY_OPTIONS_SUCCEEDED', function (data, doneCallback) {
				setStatusText(Strings.get_cloud_identity_options + Strings.done, doneCallback);
			});
			EventListenerRegistry.addOneTimeListener('GET_CLOUD_IDENTITY_SUCCEEDED', function (data, doneCallback) {
				setStatusText(Strings.get_cloud_identity + Strings.done, doneCallback);
			});


			EventListenerRegistry.addOneTimeListener([
					'WEBFONTS_LOADING_FAILED',
					'IMAGES_LOADING_FAILED',
					'GET_ATTRIBUTE_DEFINITIONS_FAILED',
					'OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_FAILED',
					'GET_OPTIONS_FAILED',
					'GET_CLOUD_IDENTITY_OPTIONS_FAILED' ], errorOccurred);

			Util.callCallbacks(doneCallback);
		};

		this.leave = function (doneCallback) {
			_splashScreenView.disableAnimation();

			EventListenerRegistry.removeListener([
					'WEBFONTS_LOADING_FAILED',
					'IMAGES_LOADING_FAILED',
					'GET_ATTRIBUTE_DEFINITIONS_FAILED',
					'OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_FAILED',
					'GET_OPTIONS_FAILED',
					'GET_CLOUD_IDENTITY_OPTIONS_FAILED' ], errorOccurred);

			Util.callCallbacks(doneCallback);
		};
	};

	InitializationState.prototype = Object.create(UIState.prototype);

	return InitializationState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/InitializationState.js
// module id = 301
// module chunks = 3